import { DataGrid, Column } from "devextreme-react/data-grid";

export default function TrackingTab(tracking) {
  const trackingData = tracking?.trackingData;

  return (
    <>
      {trackingData === null && (
        <h5>
          {" "}
          <span className="label label-warning">
            Unable to track. Manually track your tracking number(s).
          </span>{" "}
        </h5>
      )}
      <DataGrid
        dataSource={trackingData}
        showBorders={true}
        columnAutoWidth={true}
        maxHeight="300px"
        elementAttr={{ class: "tracking-grid" }}
      >
        <Column dataField="timestamp" dataType="datetime" />
        <Column dataField="location" cellRender={cellRender} />
        <Column dataField="status" />
      </DataGrid>
    </>
  );
}
const cellRender = (e) => {
  const location = e.data.location;

  if (e.data && location.city) {
    return `${location.city}, ${location.state}`;
  } else {
    return `${location.country}`;
  }
};
